/**
 * Translation key for a time-of-day greeting ("Good morning" / "afternoon" /
 * "evening").
 *
 * @param hour local hour, 0–23; before 12 is morning, before 17 afternoon, the rest evening
 */
export function greetingKey(hour: number): string {
  if (hour < 12) return 'tuition_assistance.reimagined.dashboard.greeting_morning';
  if (hour < 17) return 'tuition_assistance.reimagined.dashboard.greeting_afternoon';
  return 'tuition_assistance.reimagined.dashboard.greeting_evening';
}
